import { useMutation } from '@tanstack/react-query';

import { Query } from './api';
import { clearGatehouseSession } from '../auth/gatehouse-oauth';

export const useLogout = () => {
  return useMutation({
    // Clear local Gatehouse tokens *inside* the mutationFn (try/finally)
    // rather than in onSettled. Components like AvatarMenu read
    // logoutMutation.isSuccess and navigate to /login on the next
    // render — that render fires after mutationFn resolves but before
    // onSettled does, leaving a window where /login mounts while the
    // stale JWT is still in localStorage. Wiping here guarantees the
    // bearer is gone before any mutation state transition propagates.
    //
    // try/finally (not just success-path) so a failed /logout — e.g.
    // session already gone server-side — still wipes the local bearer;
    // otherwise the UI would keep sending the stale JWT until expiry.
    mutationFn: async () => {
      try {
        await new Query('logout').setMethod('post').run();
      } finally {
        clearGatehouseSession();
      }
    },
  });
};
